export const COLORS_INFO = {
  completed: "#8FE52B",
  accepted: "#FFE86A",
  to_pay: "#72E2E6",
  issued: "#9bf13f",
  on_stock: "#f8a358",
};

export const COLORS_CURRENCY = COLORS_INFO;
